import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import toUpper from 'lodash/toUpper'

import { useT } from '@galo-monitor/i18n'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Fertilizers from './tabs/Fertilizers'
import Manufacturers from './tabs/Manufacturers'

const FertilizersScreen = () => {
  const { pathname } = useLocation()
  const { routes } = useRoutes()
  const t = useT()

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = tab => {
        response.push(tab)
      }

      addTab({
        route: '',
        title: toUpper(t('fertilizer', { howMany: 2 })),
        Component: Fertilizers
      })

      addTab({
        route: 'manufacturers',
        title: toUpper(t('manufacturer', { howMany: 2 })),
        Component: Manufacturers
      })

      return response
    },
    [t]
  )

  const crumbs = useMemo(() => [
    (pathname.includes('manufacturers') ? {
      title: t('manufacturer', { howMany: 2 }),
      key: 'fertilizers-manufacturers-screen',
      url: '/fertilizers/manufacturers',
      active: !!pathname.match('/fertilizers/manufacturers')
    } : {
      title: routes.fertilizers.title,
      key: 'fertilizers-screen',
      url: '/fertilizers',
      active: pathname.match('/fertilizers')
    })
  ], [pathname, routes.fertilizers.title, t])

  return (
    <Screen title={ routes.fertilizers.title } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default FertilizersScreen
